// extracted by css-extract-rspack-plugin
export default {"SettingsSection":"qFnGE","PageWrapper":"QlJe7","SectionWrapper":"Mqi5K"};